/*
  lp-header.js — the phone menu toggle.

  The header's nav is desktop-only, so below the nav breakpoint the links live
  behind this button. State is a single class on the header; CSS owns every
  visual decision, including which breakpoint the button exists at.
*/
(function () {
  var OPEN = 'is-menu-open';

  function close(header, button) {
    header.classList.remove(OPEN);
    button.setAttribute('aria-expanded', 'false');
  }

  document.querySelectorAll('[data-lp-header-toggle]').forEach(function (button) {
    var header = button.closest('.lp-header');
    if (!header) return;

    button.addEventListener('click', function () {
      var open = header.classList.toggle(OPEN);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Following a link leaves the panel open behind the navigation; on an
    // in-page anchor it would stay open over the section it just jumped to.
    header.querySelectorAll('.lp-header__nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        close(header, button);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !header.classList.contains(OPEN)) return;
      close(header, button);
      button.focus();
    });

    document.addEventListener('click', function (event) {
      if (!header.classList.contains(OPEN) || header.contains(event.target)) return;
      close(header, button);
    });
  });
})();
